export const formatPrice = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? `$${amount.toFixed(2)}` : "$0.00";
};

export const getProductVariant = (product, variantLabel) => {
  if (!product?.variants?.length) return null;

  return (
    product.variants.find((variant) => variant.label === variantLabel) ||
    product.variants[0]
  );
};

export const getProductPrice = (product, variantLabel) => {
  const variant = getProductVariant(product, variantLabel);
  const amount = Number(variant?.price ?? product?.price);
  return Number.isFinite(amount) ? amount : 0;
};

export const getCartLineTotal = (product, cartItem) =>
  getProductPrice(product, cartItem?.variant || cartItem?.size) *
  Math.max(1, Number(cartItem?.quantity) || 1);

export const getCartItemKey = (item) =>
  [
    item?.id,
    item?.variant || item?.size || "default",
    item?.packaging || item?.color || "default",
  ].join("::");
